import { IconButton } from '@civilgrid/ui/components';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export type CloseIconButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'type'> & {
  'aria-label'?: string;
  'data-testid'?: string;
};

// Ref forwarding and the prop spread let Radix `Close asChild` inject its ref and handlers.
const CloseIconButton = forwardRef<HTMLButtonElement, CloseIconButtonProps>(function CloseIconButton(
  { 'aria-label': ariaLabel = 'Close', ...rest },
  ref,
) {
  return (
    <IconButton
      ref={ref}
      icon="cross2"
      iconSize={18}
      variant="hollow"
      size="icon"
      {...rest}
      aria-label={ariaLabel}
      type="button"
    />
  );
});

export default CloseIconButton;
